import { DNDMetaContext } from '@components/dnd/base';
import { DNDBlockRender } from '@library';
import type { DNDBlock } from '@stratumn/studio-shared';
import { Fragment, useContext } from 'react';

import EmptyState from './EmptyState';
import { InteractionZone } from './interaction';

type DNDRootBlockProps = {
  root: DNDBlock[];
};

export const DNDRootBlock = ({ root }: DNDRootBlockProps) => {
  const { library } = useContext(DNDMetaContext);
  if (!root) {
    return null;
  }
  if (root.length === 0) {
    return (
      <EmptyState library={library}>
        <InteractionZone dndBlock={[]} isLast={true} path={'root:root|0'} />
      </EmptyState>
    );
  }

  return (
    <>
      {root.map((blockElement, index) => (
        <Fragment key={index}>
          {index === 0 && <InteractionZone dndBlock={[]} path="root:root|0" />}
          <DNDBlockRender block={blockElement} library={library} path="root" />
          <InteractionZone
            dndBlock={[]}
            isLast={index === root.length - 1}
            path={`root:root|${index + 1}`}
          />
        </Fragment>
      ))}
    </>
  );
};
